import React from "react";

const Share = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 15.75C18 14.5074 16.9926 13.5 15.75 13.5C14.5074 13.5 13.5 14.5074 13.5 15.75C13.5 16.9926 14.5074 18 15.75 18C16.9926 18 18 16.9926 18 15.75ZM6 9.75C6 8.50736 4.99264 7.5 3.75 7.5C2.50736 7.5 1.5 8.50736 1.5 9.75C1.5 10.9926 2.50736 12 3.75 12C4.99264 12 6 10.9926 6 9.75ZM18 3.75C18 2.50736 16.9926 1.5 15.75 1.5C14.5074 1.5 13.5 2.50736 13.5 3.75C13.5 4.99264 14.5074 6 15.75 6C16.9926 6 18 4.99264 18 3.75ZM19.5 3.75C19.5 5.82107 17.8211 7.5 15.75 7.5C14.552 7.5 13.4854 6.93801 12.7988 6.06348L7.37109 8.77637C7.45439 9.08695 7.5 9.41313 7.5 9.75C7.5 10.0862 7.45408 10.4116 7.37109 10.7217L12.7988 13.4355C13.4854 12.5614 14.5522 12 15.75 12C17.8211 12 19.5 13.6789 19.5 15.75C19.5 17.8211 17.8211 19.5 15.75 19.5C13.6789 19.5 12 17.8211 12 15.75C12 15.4135 12.0448 15.0876 12.1279 14.7773L6.7002 12.0635C6.01366 12.9377 4.94783 13.5 3.75 13.5C1.67893 13.5 0 11.8211 0 9.75C0 7.67893 1.67893 6 3.75 6C4.94755 6 6.01364 6.56163 6.7002 7.43555L12.1279 4.72168C12.045 4.41171 12 4.08612 12 3.75C12 1.67893 13.6789 0 15.75 0C17.8211 0 19.5 1.67893 19.5 3.75Z"
      fill={color}
    />
  </svg>
);

Share.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Share;
